import TouchAppIcon from '@mui/icons-material/TouchApp';
import { useRecoilValue } from "recoil";
import ButtonCustom from "./ButtonCustom";
import { yellowButton } from "src/shared/styles/buttonStyles";
//import { showModalEditFiltersState } from 'src/store/reservation/reservationState';
import { historyRouteState } from 'src/store/global/historyState';

const ScheduleTimeButtom = () => {
    //const setShowModalEditFilters = useSetRecoilState(showModalEditFiltersState);
    const historyRoute = useRecoilValue(historyRouteState);

    const handleClickButton = () => {
        historyRoute?.push(process.env.REACT_APP_ROOT_SERVER_PATH);
        //setShowModalEditFilters(true)
    }

    return (
        <ButtonCustom
            onClick={handleClickButton}
            style={{ ...yellowButton }}
            text="Buscar Hora"
            icon={<TouchAppIcon />}
        ></ButtonCustom>
    )
}

export default ScheduleTimeButtom
